import React , { useState } from "react";
import { useTranslation } from 'react-i18next';
import { APIProvider, Map, AdvancedMarker } from '@vis.gl/react-google-maps';
import { ScrollRestoration } from "react-router-dom";
import SEO from "components/SEO/SEO";

//CSS
import styles from  "../staticpages.module.less";

//ICONS
import markerImage from "../../../assets/img/commons/mapicons/pickup-point.png";

const Company = () => {

  const [t] = useTranslation("pages");
  const [mailtext, setMailText]= useState(t('company.Haz clic para ver el e-mail'));

  return(
    <>
      <SEO title={t('company.SEOTitulo')} description={t('company.SEODescipcion')} name='Company name.' type='article' />

      <div className={styles.fixFlex}>
        <div className={styles.fixMain}>
          <h1>{t('company.¿Quienes somos?')}</h1>
          <p>
            {t('company.Viajes Teide, empresa fundada en 1982, es una agencia dedicada exclusivamente a la organización de excursiones en las islas. Nuestro principal objetivo es ayudar a nuestros visitantes a descubrir Tenerife. Por ello ofrecemos una amplia variedad de posibilidades para conocer lugares y municipios de interés turístico y cultural, de tal forma que usted pueda elegir entre una amplia gama de opciones. Sabemos de usted merece las mejores vacaciones. Por eso le garantizamos lo mejor cómodos autobuses con aire acondicionado y guías especializados en varios idiomas, que le atenderán en todo momento. Nuestro departamento de grupos, dedicado en exclusiva a la organización de programas especiales para incentivos y convenciones, asegura la más alta calidad de servicios, para una plena satisfacción del cliente.')}
          </p>
          <br /><br />
          <h1>{t('company.Estamos aquí')}</h1>
          <APIProvider apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}>
            <Map
              className={styles.companyMap}
              defaultZoom={17}
              defaultCenter={{ lat: 28.068, lng: -16.728229522705078}}
              mapTypeId={'roadmap'}
              mapId={'vtmeetignpointmap'}
              gestureHandling={'greedy'}
              disableDefaultUI={true} >
              <AdvancedMarker
                position={{lat: 28.068147417541805, lng: -16.728229522705078}}
                clickable={false}
              >
                <img src={markerImage} width={32} height={32} />
              </AdvancedMarker>
            </Map>
          </APIProvider>

          {/*<Wrapper apiKey={"AIzaSyDVbakMF2IWTPds0v1Yye_zrPpqHHU63kw"} render={renderMap} />*/}
        </div>

        <div className={styles.fixSidebar}>
          <div className={styles.companyContact}>
            <h2>Viajes Teide</h2>
            <p>
              Tenerife Excursions<br />
              Avn. V Centenario, 2 Local 5<br />
              Las Americas, 38670 - Adeje<br />
              Santa Cruz de Tenerife
            </p>

            <h2>{t('company.Horario')}</h2>
            <p>{t('company.Todos los días de 0700h a 2200h')}</p>

            <h2>{t('company.Contacto')}</h2>
            <p>
              {t('company.Tlf')}: +34 922 795 864<br />
              {t('company.Fax')}: +34 922 769 652<br />
              <span className={styles.mailText} onClick={()=>setMailText(atob("aW5mb0B2aWFqZXN0ZWlkZS5lcw=="))}>{mailtext}</span>
            </p>
          </div>

          {/*<div className={styles.companyMail}>
            <form method="post" action="">
              <h2>{t('company.Le podemos ayudar').toUpperCase()}</h2>
              <label>{t('company.Escriba su nombre y apellidos')}</label>
              <input type="text" name="name" />
              <label>{t('company.Direccion de E-mail')}</label>
              <input type="text" name="mail" />
              <label>{t('company.Tema del mensaje')}</label>
              <input type="text" name="subject" />
              <label>{t('company.Escriba su mensaje')}</label>
              <textarea name="message"></textarea>

              <input type="checkbox" name="copy" value="1" />
              <span>{t('company.Enviar una copia a su e-mail')}</span>
              <input type="submit" value={t('company.Enviar')} />
            </form>
          </div>*/}
        </div>
      </div>
      <ScrollRestoration />
    </>
  );
}

export default Company;